import { useMemo } from 'react';
import { PageRedirectToMobileApp } from 'pages';
import type { MobilePlatform } from 'features/onboarding';
import type { RouterConfig } from '../Router';

type MobileRouterConfig = {
  platform: MobilePlatform;
} & Omit<RouterConfig, 'isMobileRouter' | 'platform'>;

export const useMobileRouter = ({ onContinueInBrowser, platform }: MobileRouterConfig) =>
  useMemo(
    () => ({
      element: <PageRedirectToMobileApp onContinueInBrowser={onContinueInBrowser} platform={platform} />,
      path: '*',
    }),
    [onContinueInBrowser, platform],
  );
